/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import * as Styled from './PlanLimitWarning.styled';

const PlanLimitWarning = () => {
  return (
    <Styled.PlanLimitWarning
      kind="warning"
      title="Plan's limit reached"
      titleId="plan-limit-warning-title"
      lowContrast
      actionButtonLabel={'Learn more'}
      onActionButtonClick={() =>
        window.open('https://docs.camunda.io/docs/next/components/modeler/web-modeler/collaboration/')
      }
    >
      You have reached your plan’s limit of 5 users for this project. Upgrade your plan to add more users.
    </Styled.PlanLimitWarning>
  );
};

export default PlanLimitWarning;
